module.exports = __webpack_public_path__ + "static/media/38-1.2dedfced.mp3";